// StickySection.tsx
import {ReactNode} from 'react';
import {useScrollContext} from '../../context/scrollContext/ScrollContext';

interface StickySectionProps {
  children: ReactNode;
  className?: string;
  position?: 'top' | 'bottom';
  topOffset?: string;
  bottomOffset?: string;
  hasShadow?: boolean;
}

const StickySection = ({
  children,
  className,
  position = 'bottom',
  topOffset = '3.5rem',
  bottomOffset = '3.5rem',
  hasShadow = true,
}: StickySectionProps) => {
  const {isScrollingDown} = useScrollContext();

  const isBottom = position === 'bottom';

  const shadowClass = isBottom
    ? 'shadow-[0_-1px_6px_0_rgba(0,0,0,0.1)]'
    : 'shadow-[0_1px_6px_0_rgba(0,0,0,0.1)]';

  const positionClass = isBottom
    ? isScrollingDown
      ? 'bottom-0'
      : 'bottom-[var(--sticky-bottom-offset)]'
    : isScrollingDown
    ? 'top-[var(--sticky-top-offset)]'
    : 'top-0';

  // Only show spacer when there's an offset to account for
  const showSpacer = isBottom ? !isScrollingDown : isScrollingDown;

  return (
    <>
      {showSpacer && <div className="flex-shrink-0 h-12" />}
      <div
        style={
          {
            '--sticky-bottom-offset': bottomOffset,
            '--sticky-top-offset': topOffset,
          } as React.CSSProperties
        }
        className={`fixed left-0 right-0 z-50 w-full flex flex-col gap-3 px-4 py-2 bg-white transition-all duration-300 ${positionClass} ${
          hasShadow && shadowClass
        } ${className || ''}`}
      >
        {children}
      </div>
    </>
  );
};

export default StickySection;
